import SEO from "@/components/SEO";
import { Reveal, GoldRule } from "@/components/Shared";
import { HairHero, HairBreadcrumb, HairBand, HairEyebrow, HairHeading, Paras, HairCTABand } from "@/components/HairShared";
import { StickyCTA } from "@/components/Landing";
import { OFFERS } from "@/data/landing";
import { getTeamMember } from "@/data/content";
import { HAIR_BREADCRUMBS, HAIR_HERO, HAIR_PILLARS, TRUONG_HAIR_PROFILE } from "@/data/hair";

const HairDoctor = () => {
  const truong = getTeamMember("truong");
  const p = TRUONG_HAIR_PROFILE;
  const crumbs = HAIR_BREADCRUMBS.child("Dr Kristy Truong", "/hair/dr-kristy-truong");

  return (
    <>
      <SEO
        title={p.seoTitle}
        description={p.seoDescription}
        ogImage={truong.photo}
        jsonLd={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Physician",
              name: truong.name,
              url: "https://www.lumiereaesthetics.com.au/hair/dr-kristy-truong",
              image: `https://www.lumiereaesthetics.com.au${truong.photo}`,
              medicalSpecialty: "Hair restoration",
              worksFor: { "@type": "MedicalClinic", name: "Lumière Aesthetics", address: "Shop 3/40 Marine Parade, Cottesloe WA 6011" },
            },
            { "@type": "BreadcrumbList", itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: `https://www.lumiereaesthetics.com.au${c.to}` })) },
          ],
        }}
      />
      <HairHero eyebrow={p.eyebrow} title={truong.name} standfirst={p.standfirst} offer={OFFERS.hair} image={HAIR_HERO.portrait} testId="hair-doctor-hero" />
      <HairBreadcrumb items={crumbs} />

      {p.sections.map((section, i) => (
        <HairBand key={section.heading} dark={i % 2 === 1} narrow testId={`hair-doctor-section-${i}`}>
          <Reveal>
            <HairEyebrow className="mb-4">{section.heading}</HairEyebrow>
            <Paras items={section.paras} dark={i % 2 === 1} />
          </Reveal>
        </HairBand>
      ))}

      <HairBand dark={p.sections.length % 2 === 1} testId="hair-doctor-pillars">
        <Reveal className="mb-12">
          <HairEyebrow className="mb-3">What you can expect</HairEyebrow>
          <HairHeading dark={p.sections.length % 2 === 1}>Five things, every time.</HairHeading>
          <GoldRule className="mt-6" />
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10">
          {HAIR_PILLARS.map((pillar, i) => (
            <Reveal key={pillar.title} delay={i * 0.07}>
              <div className="border-t border-gold/60 pt-5" data-testid={`hair-pillar-${i}`}>
                <h3 className={p.sections.length % 2 === 1 ? "text-warm-white" : "text-ink"}>{pillar.title}</h3>
                <p className={`text-sm mt-2 leading-relaxed ${p.sections.length % 2 === 1 ? "text-warm-white/70" : "text-ink/70"}`}>{pillar.line}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </HairBand>

      <HairBand sand narrow testId="hair-doctor-note">
        <Reveal>
          <p className="font-serif italic text-ink text-2xl sm:text-3xl leading-snug border-l-2 border-gold pl-8" data-testid="hair-doctor-quote">“{truong.note}”</p>
          <p className="eyebrow text-gold mt-6">{truong.name} · {truong.title}</p>
        </Reveal>
      </HairBand>

      <StickyCTA practitioner="Dr Kristy Truong" hair />
      <HairCTABand />
    </>
  );
};

export default HairDoctor;
